<form [formGroup]="instrumentFormGroup" class="form-control-wrapper options-list-dropdown mt-10">
    <mat-form-field class="payment-method-options">
        <mat-select
            class="payment-option"
            formControlName="instrumentFormCtrl"
            id="instrumentFormCtrl"
            (selectionChange)="onChange($event)"
            disableOptionCentering>
            <mat-select-trigger>
                <option-content
                    class="d-flex align-items-center"
                    [usedOption]="selectedPaymentMethod"
                    [isUSLabel]="isUSLabel"
                    [class.disabled]="selectedPaymentMethod?.isESRiskPlayer || selectedPaymentMethod?.ESIntensiveGreyOut" />
                @if (selectedPaymentMethod?.ESIntensiveGreyOut) {
                    <div class="drop-down-option-position position-absolute d-flex align-items-center">
                        <span class="txt-sm-v2 mr-1">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message' | translate }}</span>
                        <span
                            class="theme-info-i"
                            (click)="$event.stopPropagation()"
                            [popper]="tooltipcontent2"
                            [popperPositionFixed]="true"
                            [popperTrigger]="popperTrigger"
                            [popperPlacement]="popperPlacementBottom"></span>
                    </div>
                }
                <popper-content class="tooltip-info ngxp__tooltip" #tooltipcontent2>
                    <div class="intensive-player-message">
                        <strong class="h6-v2">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message1' | translate }}</strong>
                        <p class="tooltip-description" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.intensive.player.message2' | translate"></p>
                        <a (click)="moreInfoLink()" class="tooltip-description"
                            ><span class="float-right"
                                ><b>{{ 'PARTY.CASHIER.web.deposit.intensive.player.message3' | translate }}</b></span
                            ></a
                        >
                    </div>
                </popper-content>
            </mat-select-trigger>

            @for (usedOption of usedOptions; track usedOption; let i = $index) {
                <div class="betlsip-option">
                    <mat-option
                        [disabled]="
                            (maxFailDepEnhancementEnabled && usedOption?.userMaxFailDepStatus?.blocked) ||
                            usedOption?.isESRiskPlayer ||
                            usedOption?.ESIntensiveGreyOut
                        "
                        class="p-0 ml-2 payment-option-list"
                        [value]="usedOption">
                        <option-content
                            [class.disabled]="
                                (maxFailDepEnhancementEnabled && usedOption?.userMaxFailDepStatus?.blocked) ||
                                usedOption?.isESRiskPlayer ||
                                usedOption?.ESIntensiveGreyOut
                            "
                            class="d-flex align-items-center"
                            [usedOption]="usedOption"
                            [isUSLabel]="isUSLabel"></option-content>

                        @if (maxFailDepEnhancementEnabled && usedOption?.userMaxFailDepStatus?.blocked) {
                            <div class="drop-down-option-position position-absolute d-flex align-items-center">
                                <span
                                    (click)="stopPropogation($event)"
                                    class="txt-sm-v2 theme-info-i"
                                    [popper]="tooltipcontent"
                                    [popperPositionFixed]="true"
                                    [popperTrigger]="popperTrigger"
                                    [popperPlacement]="popperPlacementBottom"></span>
                            </div>
                        }
                        @if (usedOption?.ESIntensiveGreyOut) {
                            <div class="drop-down-option-position position-absolute d-flex align-items-center">
                                <span class="txt-sm-v2 mr-1">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message' | translate }}</span>
                                <span
                                    class="theme-info-i"
                                    (click)="$event.stopPropagation()"
                                    [popper]="tooltipcontent1"
                                    [popperPositionFixed]="true"
                                    [popperTrigger]="popperTrigger"
                                    [popperPlacement]="popperPlacementBottom"></span>
                            </div>
                        }
                    </mat-option>

                    <popper-content class="tooltip-info ngxp__tooltip" id="tooltipcontent" #tooltipcontent>
                        <div class="curfew-blue">
                            <strong class="h6-v2">{{ 'PARTY.CASHIER.web.deposit.mfde.payment.method.hold.header' | translate }}</strong>
                            <p class="tooltip-description">
                                <span class="txt-sm-v2"
                                    >{{
                                        'PARTY.CASHIER.web.deposit.mfde.payment.method.hold.tooltip'
                                            | translate
                                                : {
                                                      time: usedOption?.userMaxFailDepStatus?.blockEndTime,
                                                      date: usedOption?.userMaxFailDepStatus?.blockEndDate,
                                                  }
                                    }}
                                </span>
                            </p>
                        </div>
                    </popper-content>
                    <popper-content class="tooltip-info ngxp__tooltip" id="tooltipcontent{{ i }}" #tooltipcontent1>
                        <div class="intensive-player-message">
                            <strong class="h6-v2">{{ 'PARTY.CASHIER.web.deposit.intensive.player.message1' | translate }}</strong>
                            <p class="tooltip-description" [vnDynamicHtml]="'PARTY.CASHIER.web.deposit.intensive.player.message2' | translate"></p>
                            <a (click)="moreInfoLink()" class="tooltip-description"
                                ><span class="float-right"
                                    ><b>{{ 'PARTY.CASHIER.web.deposit.intensive.player.message3' | translate }}</b></span
                                ></a
                            >
                        </div>
                    </popper-content>
                </div>
            }
            @if (!hideAllDepositOptions) {
                <mat-option [value]="'allDepositOptions'" class="p-0">
                    <div class="d-flex align-items-center">
                        <div class="payment-method-logo payment-method-moreoptions"></div>
                        <p class="all-payment-option">
                            {{ 'PARTY.CASHIER.web.deposit.allOptions' | translate }}
                        </p>
                    </div>
                </mat-option>
            }
        </mat-select>
    </mat-form-field>
</form>

@if (ccDepositLimitCheckEnabled && optionListService.selectedOption?.creditCard) {
    <show-message id="creditcard_deposit_limit_message2" [type]="messageType.INFO">
        <p
            info
            [vnDynamicHtml]="
                'PARTY.CASHIER.web.deposit.ny.creditcard.deposit.limit.annual.message'
                    | translate
                        : {
                              annualLimit: ccCurrentDepositLimit | vnCurrency: currencyUSD,
                          }
            "></p>
    </show-message>
}
@let accountbalanceInfo = optionListService.selectedOption?.accountBalance;
@let curencyCode = optionListService.selectedOption?.paymentMethodInfo?.minDepositLimit?.currencyCode?.toUpperCase();
@if (isInstantEchecks) {
    <div class="font-weight-bold">
        <input type="hidden" name="vipPreferredAccountNumber" [(ngModel)]="depositService.depositInfo.paymentAccountInfo.vipPreferredAccountNumber" />
        {{
            'PARTY.CASHIER.web.deposit.instantechecks.accountbalance.msg'
                | translate: { accountbalanceInfo: accountbalanceInfo | vnCurrency: curencyCode }
        }}
    </div>
}

@if (prepaidCards.includes(inputType?.toUpperCase() || '')) {
    <div class="font-weight-bold">
        {{
            'PARTY.CASHIER.web.deposit.prepaidcard.accountbalance.msg'
                | translate: { accountbalanceInfo: accountbalanceInfo | vnCurrency: curencyCode }
        }}
    </div>
}

@defer (when depositService?.QDType == 'LCGBETSLIP') {
    <div
        class="lcgbetslip"
        [ngClass]="ccFamily.includes(inputType?.toUpperCase() || '') ? 'space-between-width-50' : 'non-cc-amt-field'"
        [class.disabled]="isESRiskPlayer || isESIntensivePlayer">
        @if (optionListService.selectedOption?.paymentMethodInfo?.paymentMethod != 'FLASH1VOUCHER') {
            @if (amountFieldFormGroup && optionListService.selectedOption) {
                <lcg-amount-grid
                    [lcgAmountFormGroup]="amountFieldFormGroup"
                    [selectedOption]="optionListService.selectedOption"
                    [gridData]="gridData" />
            }
        }
        @if (ccFamily.includes(inputType?.toUpperCase() || '') && instrumentInputFormGroup) {
            <app-cc-input [ccInputFormGroup]="instrumentInputFormGroup" />
        }
        @if (inputType === 'FLASH1VOUCHER' && instrumentInputFormGroup) {
            <!-- TODO: lcd don't have FLASH1VOUCHER (Remove it Later) -->
            <app-flash1-voucher-input [voucherInputFormGroup]="instrumentInputFormGroup" (voucherPin)="updateVoucher()" />
        }
    </div>
    @if (optionListService.selectedOption?.paymentMethodInfo?.paymentMethod != 'FLASH1VOUCHER') {
        <lcg-amount-grid-buttons [currency]="depositInfo?.amountInfo?.nativeCurrency" (data)="fillAmount($event)" />
    }
}

@if (depositService.QDType == 'GVCBETSLIP') {
    <div
        [ngClass]="ccFamily.includes(inputType?.toUpperCase() || '') ? 'space-between-width-50  cc-amt-field' : 'non-cc-amt-field'"
        [class.disabled]="isESRiskPlayer || isESIntensivePlayer">
        @if (
            optionListService.selectedOption?.paymentMethodInfo?.paymentMethod != 'FLASH1VOUCHER' &&
            amountFieldFormGroup &&
            optionListService.selectedOption
        ) {
            <gvc-amount-grid
                [gvcAmountFormGroup]="amountFieldFormGroup"
                [selectedOption]="optionListService.selectedOption"
                [gridData]="gridData"
                (showKeyboard)="showHideKeyboard($event)"
                (depositLimitCheckEnabled)="depositLimitCheckEnabled($event)" />
        }
        @if (ccFamily.includes(inputType?.toUpperCase() || '') && instrumentInputFormGroup) {
            <app-cc-input class="ml-2" [ccInputFormGroup]="instrumentInputFormGroup" (showKeyboard)="showHideKeyboard($event)"> </app-cc-input>
        }
        @if (inputType === 'FLASH1VOUCHER' && instrumentInputFormGroup) {
            <app-flash1-voucher-input [voucherInputFormGroup]="instrumentInputFormGroup" />
        }
    </div>
    @if (showKeyboard) {
        <app-numeric-keyboard
            [currentValue]="currentValue"
            [controlName]="controlName"
            [cvvMaxLength]="maxLength"
            (returnValue)="handleKeyboardData($event)"
            (keyboardStatus)="keyboardStatus($event)" />
    }
    @if (optionListService.selectedOption?.paymentMethodInfo?.paymentMethod != 'FLASH1VOUCHER') {
        <gvc-amount-grid-buttons (data)="fillAmount($event)" />
    }
}
@if (optionListService.selectedOption?.paymentMethodInfo?.paymentMethod == 'GOOGLEPAY') {
    <show-message [type]="messageType.INFO">
        <div info>
            <p>{{ 'PARTY.CASHIER.web.deposit.gpay.depositText' | translate }}</p>
        </div>
    </show-message>
}

@if (depositInfo.isBelgiumRgDecreeEnabled && amountFieldFormGroup.controls['userAmount'].status === 'VALID' && rgLimitData) {
    <bqd-threshold-limit />
}
@if (
    amountFieldFormGroup &&
    amountFieldFormGroup.controls['userAmount'] &&
    ((amountFieldFormGroup && amountFieldFormGroup.controls['userAmount'].dirty) ||
        (amountFieldFormGroup && amountFieldFormGroup.controls['userAmount'].touched)) &&
    amountFieldFormGroup.controls['userAmount'].hasError('selfSetLimit') &&
    optionListService.selectedOption
) {
    <app-deposit-limit-message [selectedOption]="optionListService.selectedOption" [showCCDepositLimitCheckMsg]="showDepositLimitMsg" />
}

@defer (when depositService?.QDType == 'GVCBETSLIP') {
    @if (depositService.showBonusInput && !depositService.showDepositSuccess() && optionListService.selectedOption) {
        <app-bonus-input [selectedOption]="optionListService.selectedOption" />
    }
}
@defer (when inputType === 'GAMERSCARD') {
    <app-password-block />
}
